(function ($) {
    'use strict';
    $.widget("fd.control_datepicker", {
        options: {
            parentid: null,
            callback: function () { },
            mindate: null,
            maxdate: null,
            format: 'mmmm d, yyyy',
            formatsubmit: 'yyyy-mm-dd',
            formatmoment: 'YYYY-MM-DD',
            hiddenName: true,
            disabledays: [],    // Array of days of the week, numbered 1 - 7.
            allowclear: true,
            container: null,
            selectYears: true,
            selectMonths: true,
            alignright: false
        },
        _create: function () {
            const that = this;
            let lastValue;
            let pickadate;
            let skipHandleSubmit = false;

            if (!this.options.parentid) {
                this.options.parentid = this.element.closest('[data-fd-parentid]').data('fd-parentid');
            }
            const datepickerOptions = {
                disable: this.options.disabledays,
                format: this.options.format,
                formatSubmit: this.options.formatsubmit,
                hiddenName: this.options.hiddenName,
                clear: this.options.allowclear ? 'Clear' : '',
                selectYears: this.options.selectYears,
                selectMonths: this.options.selectMonths,
                onSet: function (context) {
                    if (context.highlight) {
                        return; // control is just setting the highlight option, not setting any values
                    }

                    if ((context.clear !== undefined || context.select !== undefined && !context.select) && !that.options.allowclear) {
                        skipHandleSubmit = true;
                        pickadate.set('select', lastValue);
                    } else if (skipHandleSubmit) {
                        skipHandleSubmit = false;
                    } else {
                        lastValue = context.select;
                        that._handleSubmit(this, context);
                    }
                }
            };
            if (this.options.mindate) {
                datepickerOptions.min = new Date(this.options.mindate);
            }
            if (this.options.maxdate) {
                datepickerOptions.max = new Date(this.options.maxdate);
            }
            if (this.options.container) {
                datepickerOptions.container = this.options.container;
            }

            this._datepickerInstance = this.element.pickadate(datepickerOptions);
            if (this.options.alignright) {
                this.element.next().find(".picker__holder").css("right", 0);
            }
            pickadate = this._datepickerInstance.data().pickadate;
            lastValue = pickadate.get();
            
            const target = this.element.parent().find('[type=hidden]');
            target.attr('class', this.element.attr('class'));
            this.element.addClass('ignore-validators');

            const attributes = this.element[0].attributes;
            for (let i = 0; i < attributes.length; i++) {
                if (attributes[i].name.startsWith('data-val')) {
                    target.attr(attributes[i].name, attributes[i].value);
                }
            }

            // don't tab to the pickadate buttons
            (this.options.container ? $(this.options.container) : $(this.element).next()).find('button').attr('tabindex', -1);
        },
        _handleSubmit: function (datepicker, context) {
            this.options.callback.call(this, {
                parentid: this.options.parentid,
                value: context.select ? moment(context.select).format(this.options.formatmoment) : null // If select isn't defined, they pressed the clear button
            }, datepicker);
            if (this.element.closest('form').validate().currentElements.length > 0) {
                this.element.parent().find('[type=hidden]').valid();
            }
        },
        _datepickerInstance: null,
        _setOption: function (key, value) {
            this.options[key] = value;
        }
    });
}(jQuery));